/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuthRegisterRequestBodyAllOf } from './AuthRegisterRequestBodyAllOf';
import {
    AuthRegisterRequestBodyAllOfFromJSON,
    AuthRegisterRequestBodyAllOfFromJSONTyped,
    AuthRegisterRequestBodyAllOfToJSON,
} from './AuthRegisterRequestBodyAllOf';

/**
 * 
 * @export
 * @interface AuthLoginRequestBody
 */
export interface AuthLoginRequestBody {
    /**
     * 
     * @type {string}
     * @memberof AuthLoginRequestBody
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthLoginRequestBody
     */
    password?: string;
}

/**
 * Check if a given object implements the AuthLoginRequestBody interface.
 */
export function instanceOfAuthLoginRequestBody(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AuthLoginRequestBodyFromJSON(json: any): AuthLoginRequestBody {
    return AuthLoginRequestBodyFromJSONTyped(json, false);
}

export function AuthLoginRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthLoginRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function AuthLoginRequestBodyToJSON(value?: AuthLoginRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
    };
}

